import React from 'react';
import { Modal, Button, ProgressBar } from 'react-bootstrap';
import { useCampaign, CampaignProvider } from '../CampaignContext';
import Step1Title from './Step1Title';
import Step2Audience from './Step2Audience';
import Step3Template from './Step3Template';
import Step4Schedule from './Step4Schedule';
import '../WhatsappCampaignManager.scss';

const CampaignWizardContent = ({ onHide }) => {
    const { state, dispatch } = useCampaign();
    const { activeStep } = state;

    const steps = [
        { title: 'CAMPAIGN TITLE', component: <Step1Title /> },
        { title: 'AUDIENCE', component: <Step2Audience /> },
        { title: 'MESSAGE & TEMPLATE', component: <Step3Template /> },
        { title: 'SCHEDULE', component: <Step4Schedule /> }
    ];

    const nextStep = () => {
        if (activeStep < steps.length - 1) {
            dispatch({ type: 'SET_STEP', payload: activeStep + 1 });
        }
    };

    const prevStep = () => {
        if (activeStep > 0) {
            dispatch({ type: 'SET_STEP', payload: activeStep - 1 });
        }
    };

    const handleSubmit = async () => {
        dispatch({ type: 'SET_LOADING', payload: true });
        try {
            // Data transformation and API call logic will go here
            console.log("Final Campaign Payload:", state);
            alert("Campaign Scheduled Successfully!");
            onHide();
        } catch (error) {
            dispatch({ type: 'SET_ERROR', payload: error.message });
        } finally {
            dispatch({ type: 'SET_LOADING', payload: false });
        }
    };

    return (
        <>
            <Modal.Header closeButton className="wcm-wizard-header">
                <div>
                    <h5 className="m-0">Campaign Creation Wizard</h5>
                    <p className="m-0">Step {activeStep + 1} of 4: {steps[activeStep].title}</p>
                </div>
            </Modal.Header>
            <Modal.Body className="p-4 wcm-modal-body">
                <div className="mb-4">
                    <ProgressBar
                        now={((activeStep + 1) / steps.length) * 100}
                        className="wcm-progress-bar"
                    />
                    <div className="d-flex justify-content-between mt-2 px-1">
                        {steps.map((s, idx) => (
                            <span
                                key={idx}
                                className={`wcm-step-indicator ${idx <= activeStep ? 'active' : 'inactive'}`}
                            >
                                {s.title}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="campaign-wizard-content pt-2">
                    {steps[activeStep].component}
                </div>
            </Modal.Body>
            <Modal.Footer className="bg-light border-0 px-4 pb-4">
                <Button variant="link" className="text-muted mr-auto" onClick={onHide}>
                    Cancel
                </Button>
                {activeStep > 0 && (
                    <Button variant="outline-primary" onClick={prevStep} className="px-4">
                        Previous
                    </Button>
                )}
                {activeStep < steps.length - 1 ? (
                    <Button variant="primary" onClick={nextStep} className="px-5 shadow-sm ml-2">
                        Next
                    </Button>
                ) : (
                    <Button variant="success" onClick={handleSubmit} className="px-5 shadow-sm ml-2">
                        Finish & Submit
                    </Button>
                )}
            </Modal.Footer>
        </>
    );
};

const CampaignWizard = ({ show, onHide }) => {
    return (
        <Modal 
            show={show} 
            onHide={onHide} 
            size="xl" 
            centered 
            backdrop="static" 
            scrollable={true}
            className="campaign-wizard-modal"
        >
            <CampaignProvider>
                <CampaignWizardContent onHide={onHide} />
            </CampaignProvider>
        </Modal>
    );
};

export default CampaignWizard;
